module.exports = __webpack_public_path__ + "static/media/amazon.51c9a0a0.svg";